module.exports = __webpack_public_path__ + "static/img/maintenance-mode.c4d34803.svg";